import { useRoutes } from "react-router-dom";
// routes
import MainRoutes from "./MainRoutes";
import PrivateRoutes from "./PrivateRoutes";
import { useAppSelector } from "../redux/store";
import { DashboardMobileNavProvider } from "../context/DashboardMobileNavContext";

// ==============================|| ROUTING RENDER ||============================== //

export default function CombineRoutes() {
    const auth = useAppSelector((state) => state.auth);
    const routes = useRoutes(
        [auth.isLoggedIn ? PrivateRoutes : [], MainRoutes],
        process.env.BASENAME,
    );
    return (
        <DashboardMobileNavProvider>{routes}</DashboardMobileNavProvider>
    );
}
